import { Component, Inject, OnInit } from '@angular/core';
import { EmpresasService } from '../../../services/empresas.service';
import { HelpersService } from '../../../services/tools/helpers.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
declare var $;
@Component({
  selector: 'app-registrar-empresa-modal',
  templateUrl: './registrar-empresa-modal.component.html',
  styleUrls: ['./registrar-empresa-modal.component.scss']
})
export class RegistrarEmpresaModalComponent implements OnInit {

  public isUpdate: boolean = false;
  public empresa: any = {};
  public errors:any = {};
  public processing: boolean = false;
  
  constructor(
    private service: EmpresasService,
    private helperService: HelpersService,
    public dialogRef: MatDialogRef<RegistrarEmpresaModalComponent>,
    @Inject (MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.isUpdate = this.data.flag;
    this.empresa = this.service.getDefaultSchedule();
    if(this.isUpdate){
      this.empresa = this.data.empresa;
    }else{
      this.empresa = {};
    }
  }

  public close(){
    this.dialogRef.close({update:false})
  }

  public accept(){
    
    //Validar
    this.errors = this.service.validate(this.empresa);
    
    if(!$.isEmptyObject(this.errors)){
      return false;
    }
    
    if(this.isUpdate){
      console.log("Entro a aceptar validación");
      this.updateEmpresa();
    }else {
      this.addEmpresa();
    }
  }

  public addEmpresa(){
    this.service.registrarEmpresa(this.empresa)
     .subscribe(response => {
       const datosEmpresa = response.json();

       console.log("Resp service empresa: ",datosEmpresa);

       this.processing = false;
       if (datosEmpresa.success) {
         this.helperService.notification('Empresa agregada', 'Se ha creado exitosamente el registro de la empresa', 'success');
         this.dialogRef.close();
         setTimeout(() => {window.location.reload()},3000);
         
       }
     }, error => {
       //this.processing = false;
       if(error.status == 400) {
         this.showServicesErrors(error.json().content);
       }else{
         this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
       }
       
       // se resuelven los errores 403 y 500
       this.helperService.httpGlobalError(error, false);
     });
  }

  public updateEmpresa(){
    console.log("Se va actualizar: ",this.empresa);
    this.service.updateEmpresa(this.empresa.id, this.empresa)
      .subscribe(response => {
        const respuesta = response.json();
        if (respuesta.success) {
          this.helperService.notification('Empresa actualizada', 'Se ha actualizado exitosamente', 'success');
          //Poner dentro del success response
          this.dialogRef.close({update:true, new: this.empresa});
        }
      }, error => {
        if(error.status == 400) {
          this.showServicesErrors(error.json().content);
        }else{
          this.dialogRef.close({update:false});
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
        
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);
      });
  }

  private showServicesErrors(errors:any[]){
    //Es posible que en algún momento se necesiten parsear los errores ya que las llaves del backend,
    //no correspondan con las llaves de los errores del front
    this.errors = errors;
  }
}



// WEBPACK FOOTER //
// ./src/app/administracion/empresas/registrar-empresa-modal/registrar-empresa-modal.component.ts